export enum EmissionStage {
  新能源 = '新能源',
  国一 = '国一',
  国二 = '国二',
  国三 = '国三',
  国四 = '国四',
  国五 = '国五',
  国六 = '国六',
}
